import { render, staticRenderFns } from "./FilterTypeVintage.vue?vue&type=template&id=6ff14a0e&"
import script from "./FilterTypeVintage.vue?vue&type=script&lang=js&"
export * from "./FilterTypeVintage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports